var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:{ 'funding-method-image': !_vm.large, 'pr-3': _vm.useImagePadding },attrs:{"src":_vm.imageSrc.asset,"alt":_vm.imageSrc.label}})
}
var staticRenderFns = []

export { render, staticRenderFns }